import { render, staticRenderFns } from "./ResultConfigVoip.vue?vue&type=template&id=1a72394b&"
import script from "./ResultConfigVoip.vue?vue&type=script&lang=js&"
export * from "./ResultConfigVoip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports